import { selectBasket } from 'containers/OrderDetails/basketSlice'
import useTranslation from 'hooks/useTranslation'
import { BrowserRouter } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { useSelector } from 'react-redux'
import { useState, useRef } from 'react'
import { closeCart } from 'rest/urls'
import { POST } from 'rest/request'

const Router = ({ children }) => {
  const [isPrompt, setPrompt] = useState(false)
  const prompt = useRef({
    message: '',
    callback: () => { }
  })

  return (
    <BrowserRouter
      getUserConfirmation={(message, callback) => {
        prompt.current = { message, callback }
        setPrompt(true)
      }}>
      {children}
      {isPrompt && <Prompt
        {...prompt.current}
        setPrompt={setPrompt}
      />}
    </BrowserRouter>
  )
}

const Prompt = ({ message, callback, setPrompt }) => {
  const { cartId } = useSelector(selectBasket);
  const { t } = useTranslation('prompts')

  const handleCloseCart = async () => {
    if (!cartId) return
    try {
      await POST(closeCart(cartId))
      console.log('Zamknij rezerwacje koszyka: ' + cartId)
    } catch (error) {
      console.error('Błąd podczas zamykania koszyka: ', error)
    }
  }

  const close = (result) => {
    callback(result)
    setPrompt(false)
  }

  switch (message) {
    case 'order': return (
      <Popup
        isPopup
        close={() => {
          close(false)
        }}>
        <div className='popup__basket--warning'>
          <h3>{t('order.title')}</h3>
          <p>{t('order.content')}</p>
          <div className='popup__buttons group'>
            <div
              className='button --cancel'
              onClick={() => {
                close(false)
              }}>
              {t('order.no')}
            </div>
            <div
              className='button --accept'
              onClick={() => {
                handleCloseCart()
                close(true)
              }}>
              {t('order.yes')}
            </div>
          </div>
        </div>
      </Popup>
    )


    case 'contract': return (
      <Popup
        isPopup
        close={() => {
          close(false)
        }}>
        <div className='popup__basket--warning'>
          <h3>{t('contract.title')}</h3>
          <p>{t('contract.content')}</p>
          <div className='popup__buttons center'>
            <div
              className='button --accept'
              onClick={() => {
                close(false)
              }}>
              {t('contract.close')}
            </div>
          </div>
        </div>
      </Popup>
    )

    default: return null
  }
}

export default Router